import api from '@/interface/baseApi'

//获取企业微信和应用签名
export function getQwSignature(form) {
	return api({
		url: '/qywx/qwglobal/getQwSignature',
		method: 'post',
		data:{
			app: form.app,
			url: form.url,
		}
	})
}

//获取企业微信签名
export function getQwCorpSignature(form) {
	return api({
		url: '/qywx/qwglobal/getQwCorpSignature',
		method: 'post',
		data:{
			app: form.app,
			url: form.url,
		}
	})
}

//获取企业微信应用签名
export function getQwAgentSignature(form) {
	return api({
		url: '/qywx/qwglobal/getQwAgentSignature',
		method: 'post',
		data:{
			app: form.app,
			url: form.url,
		}
	})
}